// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('resellerorder.resellerordercreate', {
        url: '/new/',
        templateUrl: 'main/resellerorder/resellerordercreate/resellerordercreate.tpl.html',
        controller: 'ResellerOrderCreateController as vm',
        resolve: {
            resellerOrder: function() {
                return {
                    links: [],
                    order: {
                        externalOrderNumber: '',
                        id: 0,
                        // lineItems: [],
                        resellerId: 0,
                        saleLocationId: 0,
                        status: 'Created',
                        warehouseId: 0,
                        collectionId: 0
                    }
                };
            }
        },
        params: {
        }
    });
}

// @ngInject
function ResellerOrderCreateController($rootScope, $state, $translate, resellerOrder, ResellerOrdersApiService, confirmationDialogService, loadSpinnerService, ToasterService) {
    var vm = this;

    //Properties
    vm.resellerOrder = resellerOrder.order;
    vm.resellerOrder.links = resellerOrder.links;
    vm.links = resellerOrder.links;
    vm.canAccess = $rootScope.canAccess;

    //Public methods
    vm.canCreateOrderHeader = canCreateOrderHeader;
    vm.createOrderHeader = createOrderHeader;
    vm.createNewReturnOrder = createNewReturnOrder;

    activate();

    function activate() {
    }

    function createNewReturnOrder() {
        $state.go('resellerorder.resellerreturnordercreate');
    }

    function canCreateOrderHeader() {
        var hasSetReseller = vm.resellerOrder.resellerId > 0;
        var hasSetSaleLocation = vm.resellerOrder.saleLocationId > 0;
        var hasSetWarehouse = vm.resellerOrder.warehouseId > 0;
        var hasSetCollection = vm.resellerOrder.collectionId > 0;


        return hasSetReseller && hasSetSaleLocation && hasSetWarehouse && hasSetCollection;
    }

    function createOrderHeader() {
        //call backend, save order
        console.log("order",vm.resellerOrder);
        loadSpinnerService.start('mainSpinner');
        ResellerOrdersApiService.create(vm.resellerOrder).then(function (response) {
            var orderId = response.data.id;
            $state.go('resellerorder.resellerordermodify', { orderId: orderId });
        }, function (error) {
            console.log(error);
            ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
        }).then(function () {
            loadSpinnerService.stop('mainSpinner');
        });
    }
}

angular
    .module('resellerorder.resellerordercreate', [])
    .config(stateConfig)
    .controller('ResellerOrderCreateController', ResellerOrderCreateController);
